class statusFormat {
  static status(status) {
    switch (status) {
        case 'PENDING_DELIVERY':
            return 'Aguardando entrega';
        case 'PENDING_PICKUP':
            return 'Aguardando retirada';
        case 'ACTIVE':
            return 'Em andamento';
        case 'PENDING_COMPANY_PICKUP':
            return 'Aguardando coleta';
        case 'PENDING_RETURN':
            return 'Aguardando devolução';
        case 'COMPLETED':
            return 'Locação encerrada';
        default:
            return 'Cancelado';
    }
  }
    static type(type) {
        switch (type) {
            case 'FORCE_COMPLETED':
                return 'Encerramento manual';
            case 'DELIVERED':
                return 'Entrega realizada';
            case 'PICKED_UP':
                return 'Retirada realizada';
            case 'COMPANY_PICKED_UP':
                return 'Coleta realizada';
            case 'RETURNED':
                return 'Devolução realizada';
            case 'CANCELED':
                return 'Locação cancelada';
            default:
                return 'Ação desconhecida';
        }
    }
}

export default statusFormat;